import moment from 'moment';
import {
  getMeetingReleaseReport
} from '../services/report';
import { getZoneTreeData } from '../services/calender';
import { message } from 'antd';
import {MT_RLS_KIND, MT_RLS_TYPE} from '../utils/constants';

export default {
  namespace: 'meetingRelease',
  state: {
    startTime: moment().startOf('month'),
    endTime: moment().endOf('day'),
    meetingTreeData: { child: [] },
    meetingSearchInfo: {
      moreMeeting: []
    },
    chartData: [],
    legendData: [],
    rlsData: []
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    },
    setMeetingTreeData(state, { meetingTreeData }) {
      return { ...state, meetingTreeData };
    }
  },
  effects: {
    *search(undefined, { call, select, put }) {
      const {startTime, endTime, meetingSearchInfo: {moreMeeting}} = yield select(state => state.meetingRelease);
      const { locale, messages } = yield select(state => state.i18n);
      let idStr = '';
      if (moreMeeting && moreMeeting.length > 0) {
        idStr = moreMeeting.join(';')
      }
      const {status, data} = yield call(getMeetingReleaseReport, {
        startDate: startTime.valueOf(),
        endDate: endTime.valueOf(),
        roomIds: idStr,
        locale
      });
      if (status === 0) {
        const chartData = [];
        const legendData = [];
        let total = 0;
        let num_cancel = 0;
        let num_normal = 0;
        let num_unsign = 0;
        data && data.forEach(d=>{
          chartData.push({
            rlsKind: messages[MT_RLS_KIND[d.rlsKind]],
            rlsType: messages[MT_RLS_TYPE[d.rlsType-1]],
            num: d.num
          });
          total = total + d.num;
          if (d.rlsKind === 0) {
            num_cancel = num_cancel + d.num;
          } else if (d.rlsKind === 1) {
            num_normal = num_normal + d.num;
          } else {
            num_unsign = num_unsign + d.num;
          }
        });
        if (total > 0) {
          MT_RLS_KIND.forEach(k=>{
            let num = 0;
            let color = '';
            if (k.indexOf('cancel') > -1) {
              color = '#59CC75';
              num = num_cancel;
            } else if (k.indexOf('normal') > -1) {
              color = '#45A2FF';
              num = num_normal;
            } else {
              color = '#4DCBCB';
              num = num_unsign;
            }
            legendData.push({
              name: messages[k],
              num,
              color,
              percent: `${(100*num/total).toFixed(2)}%`
            })
          })
        }
        yield put({
          type: 'setState',
          payload: { chartData, legendData, rlsData: data }
        });
      }
    },
    *getMeetingTreeDataForSearch({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      yield put({ type: 'setMeetingTreeData', meetingTreeData: data.data });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname.indexOf('releaseReport') > -1) {
          dispatch({ type: 'setState', payload: {
            startTime: moment().startOf('month'),
            endTime: moment().endOf('day'),
            meetingTreeData: { child: [] },
            meetingSearchInfo: {
              moreMeeting: []
            },
            chartData: [],
            legendData: []
          }});
          dispatch({ type: 'getMeetingTreeDataForSearch' })
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingRelease.js